/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICusPromoBannerProps } from './cus-promo-banner.props.autogenerated';
import * as React from 'react';

export interface ICusPromoBannerViewProps extends ICusPromoBannerProps<unknown> {}

export default function CusPromoBanner(props: ICusPromoBannerProps<unknown>): JSX.Element | null {
    const texts = Array.from(props.config.textList?.values?.() ?? []);
    const repeatedTexts = Array(3)
        .fill(texts)
        .flat();

    const result = repeatedTexts.flatMap((text, index, arr) => (index < arr.length - 1 ? [text, ' · '] : [text]));
    return (
        <div className='bs-promo-banner'>
            <div className='bs-promo-banner__container'>
                {result.map((text, index) => (
                    <div className='bs-promo-banner__item' key={index}>
                        {text}
                    </div>
                ))}
            </div>
        </div>
    );
}
